import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";
import { Product } from "../types/product";

// Tạo API service với createApi
export const productApi = createApi({
  reducerPath: "productApi",
    baseQuery: baseQueryWithReauth,
  // baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  tagTypes: ["product"],
  endpoints: (builder) => ({
    getAllProduct: builder.query<Product[], void>({
      query: () => "product/get-all-product",
      providesTags: (result?: Product[]) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "product" as const, _id })),
              { type: "product", _id: "LIST" },
            ]
          : [{ type: "product", _id: "LIST" }],
    }),
    getProductDetail: builder.query({
      query: (id) => ({
        url: `product/product/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, _id) => [{ type: "product", _id }],
    }),
    createOrUpdateProduct: builder.mutation({
      query: (user) => ({
        url: "product/create-or-update",
        method: "POST",
        body: user,
      }),
      invalidatesTags: ["product"],
    }),
    deleteProductById: builder.mutation({
      query: (id) => ({
        url: `product/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['product'],
    }),
    cloneProduct: builder.mutation({
      query: ({ sourceId, pid, product_name }: { sourceId: string; pid: string; product_name: string }) => ({
        url: `product/clone/${sourceId}`,
        method: "POST",
        body: { pid, product_name },
      }),
      invalidatesTags: ["product"],
    }),
  }),
});

// Export hooks để sử dụng trong component
export const {
  useGetAllProductQuery,
  useCreateOrUpdateProductMutation,
  useGetProductDetailQuery,
  useDeleteProductByIdMutation,
  useCloneProductMutation,
} = productApi;
